import { TradesProvider } from './components/cache/TradesProvider';
import LandingPage from './pages/LandingPage';
import { HashRouter as Router } from 'react-router-dom';
import { CognitoAuthProvider } from './context/CognitoAuthContext';
import { Abc3Provider } from './context/Abc3Context';

function App() {
  return (
    <CognitoAuthProvider>
      <Abc3Provider>
        <Router>
          <div>
            <TradesProvider>
              <LandingPage />
            </TradesProvider>
          </div>
        </Router>
      </Abc3Provider>
    </CognitoAuthProvider>
  );
}

export default App;
